var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0939 12.2501H73.0313V8.18756C73.0313 3.67294 69.3584 0 64.8438 0H31.1564C30.6094 0 30.0848 0.217312 29.698 0.604125L11.323 18.9791C10.9362 19.3659 10.7189 19.8906 10.7189 20.4375V75.5625C10.7189 80.0771 14.3918 83.7501 18.9064 83.7501H22.9688V87.8126C22.9688 90.0008 23.821 92.0571 25.3666 93.6006C26.9121 95.148 28.9681 96.0002 31.1562 96.0002H77.0937C81.6083 96.0002 85.2812 92.3273 85.2812 87.8126V20.4375C85.2812 15.9229 81.6085 12.2501 77.0939 12.2501ZM32.0106 4.125H32.1563V17.3749C32.1563 19.6149 30.3338 21.4374 28.0937 21.4374H14.8439V21.2917L32.0106 4.125ZM14.8439 75.5625V25.5624H28.0939C32.6086 25.5624 36.2815 21.8895 36.2815 17.3749V4.125H64.8439C67.084 4.125 68.9065 5.9475 68.9065 8.18756V75.5625C68.9065 77.8026 67.084 79.6251 64.8439 79.6251H18.9064C16.6662 79.6251 14.8439 77.8026 14.8439 75.5625ZM81.1562 87.8124C81.1562 90.0525 79.3337 91.875 77.0937 91.875H31.1562C30.0709 91.875 29.0513 91.4526 28.2833 90.6834C27.5162 89.9175 27.0938 88.8979 27.0938 87.8126V83.7501H64.8438C69.3584 83.7501 73.0313 80.0771 73.0313 75.5625V16.3751H77.0939C79.3339 16.3751 81.1564 18.1976 81.1564 20.4375V87.8124H81.1562Z",
    fill: "#22D3EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6563 40.875H28.0938C26.9547 40.875 26.0312 39.9516 26.0312 38.8125C26.0312 37.6734 26.9547 36.75 28.0938 36.75H55.6563C56.7953 36.75 57.7188 37.6734 57.7188 38.8125C57.7188 39.9516 56.7955 40.875 55.6563 40.875Z",
    fill: "#F472B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6563 53.125H28.0938C26.9547 53.125 26.0312 52.2016 26.0312 51.0625C26.0312 49.9234 26.9547 49 28.0938 49H55.6563C56.7953 49 57.7188 49.9234 57.7188 51.0625C57.7188 52.2016 56.7955 53.125 55.6563 53.125Z",
    fill: "#22D3EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4063 65.375H28.0938C26.9547 65.375 26.0312 64.4516 26.0312 63.3125C26.0312 62.1734 26.9547 61.25 28.0938 61.25H43.4063C44.5454 61.25 45.4688 62.1734 45.4688 63.3125C45.4688 64.4516 44.5454 65.375 43.4063 65.375Z",
    fill: "#F472B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.e7171076c867e2b459b2d8010529ad29.svg";
export { ForwardRef as ReactComponent };